<div class=" flex flex-col h-full ">
  <!-- HEADER -->
  <div class="w-full flex items-center justify-between pt-8 pb-2 px-8 border-b border-gray-200 shadow-lg mt-[2px] z-20"
    [style.background-color]="cultivationVariant?.backgroundColor | HexToHsl">
    <div class="flex flex-col gap-4">
      <h1 class="font-semibold text-3xl leading-7">{{cultivationVariant?.name}}</h1>
      <span
        class="font-semibold text-xs py-1 px-2 rounded-full text-[#545454] border border-[#545454] w-fit">{{getFamily()}}</span>
    </div>
    <div class="w-48 h-32 flex justify-end"><vw-icon-svg
        [iconUrl]="cultivation?.files[0].cdnUrl || '/assets/svg/tomato-3.svg'"
        additionalClasses="h-full w-36 object-contain" width="100%" height="100%"></vw-icon-svg></div>
  </div>
  <!-- CONTENT -->
  <div class="flex-1 overflow-auto p-4 flex flex-col gap-4">
    <!-- DESCRIPTION -->
    <vw-card-block [title]="'garden.guide.description'">
      <p class="text-sm text-grey-800" [innerHTML]="cultivationVariant?.description || cultivation?.description"></p>
    </vw-card-block>
    <!-- NEEDS -->
    <vw-card-block [title]="'garden.guide.needs'">
      <div class="w-full">
        <vw-needs [needs]="cultivationVariant?.needs || cultivation?.needs"></vw-needs>
      </div>
    </vw-card-block>
    <!-- PERIODS -->
    <vw-card-block [title]="'garden.guide.periods.title'">
      <div class="flex gap-4">
        <div class="flex flex-col gap-1 mt-10">
          <div class="flex items-center gap-2 transition-opacity duration-500">
            <div class="rounded-full w-6 h-2 " [style.background-color]="'#f3c518'"></div>
            <span class="text-xs text-grey-700">{{'agenda.legend.seedling' | translate}}</span>
          </div>
          <div class="flex items-center gap-2 transition-opacity duration-500">
            <div class="rounded-full w-6 h-2 " [style.background-color]="'#a4de56'"></div>
            <span class="text-xs text-grey-700">{{'agenda.legend.harvest' | translate}}</span>
          </div>
        </div>
        <div class="flex flex-col gap-2 w-full">
          <vw-calendar-months-header [currentMonth]="0">
          </vw-calendar-months-header>


          <div class="flex flex-col gap-3 w-full relative py-1">
            <div class="absolute inset-0 grid grid-cols-12">
              @for (month of [1,2,3,4,5,6,7,8,9,10,11,12]; track month) {
              <div class="col-span-1 h-full w-full border-r border-grey-50" [ngClass]="{'border-l': month === 1}"></div>
              }
            </div>
            <vw-calendar-period-line [periods]="seedPeriods" [type]="'SEEDLING'"></vw-calendar-period-line>
            <vw-calendar-period-line [periods]="harvestPeriods" [type]="'HARVEST'"></vw-calendar-period-line>
          </div>
        </div>
      </div>
    </vw-card-block>
    <!-- ASSOCIATIONS -->
    <vw-card-block [title]="'garden.guide.associations'">
      <div class="flex flex-wrap gap-2 mb-2">
        @for (relation of relations; track relation) {
        <div [ngClass]="{
                  'text-[#3D9D1D] border-[#A1E97B]': relation.type === 'FRIENDS',
                  'text-[#C5132E] border-[#F78373]': relation.type === 'ENEMIES'
                }" class="text-xs font-semibold flex items-center gap-1 border py-1 px-2 rounded-lg bg-white">
          @if (relation.type === 'FRIENDS') {
          <vw-icon-svg [iconUrl]="'/assets/svg/heart.svg'" additionalClasses="cursor-pointer" width="14"></vw-icon-svg>
          }
          @if (relation.type === 'ENEMIES') {
          <vw-close-icon class="w-3.5"></vw-close-icon>
          }
          {{ relation.name }}
        </div>
        }
      </div>
    </vw-card-block>
    <!-- RISKS -->
    <vw-card-block [title]="'garden.guide.risks'">
      <div class="flex items-center justify-center gap-4">
        @for (risk of risks; track risk) {
        <div
          class="text-base h-12 font-semibold text-primary-dark flex items-center justify-between gap-2 border border-[#EBEBEA] py-3 px-3 rounded-lg bg-white w-full">
          {{ risk.name }}
          <vw-icon-svg [iconUrl]="risk.iconUrl" additionalClasses="cursor-pointer rotate-180" width="20"></vw-icon-svg>
        </div>
        }
      </div>
    </vw-card-block>
  </div>
</div>